/*
  Card de producto de la PLP — formato A (ver snippets/masca-card-plp.liquid).

  Lo que hace:
  1. Lee la cobertura de la dirección guardada (localStorage.mascaRutas, que
     escribe el popup de ubicación) y decide qué rutas llegan.
  2. Pinta sobre la foto "Llega hoy" / "Llega mañana" según la mejor ruta que
     llega. Sin dirección NO promete nada.
  3. Deshabilita los chips de las rutas que no llegan: la Shopify Function
     bloquea en el checkout la línea cuya ruta no está habilitada, así que dejar
     agregarla solo postergaría el rechazo.
  4. El precio de la card sigue al chip elegido.
  5. Agrega al carrito NATIVO por fetch y repinta el cart drawer.
  6. Se engancha solo a las cards que aparecen después (filtros por AJAX de
     facets.js y el botón "Cargar más"), con un MutationObserver.

  El mapeo ruta <-> variante es el mismo del hero del home: "hoy" = express,
  "mañana" = nextday (que cubre también la ruta bodega).
*/
(function () {
  'use strict';

  if (window.mascaCardPlpCargado) return;
  window.mascaCardPlpCargado = true;

  var ICONO_RAYO =
    '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M13 2 4.5 13.5H11l-1 8.5 8.5-11.5H12l1-8.5Z"/></svg>';
  var ICONO_CAMION =
    '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M3 5h11v9H3V5Zm12 3h3.5L21 11.5V14h-6V8ZM6.5 19a1.8 1.8 0 1 1 0-3.6 1.8 1.8 0 0 1 0 3.6Zm11 0a1.8 1.8 0 1 1 0-3.6 1.8 1.8 0 0 1 0 3.6Z"/></svg>';

  /* ------------------------------------------------------------------ */
  /* Cobertura                                                           */
  /* ------------------------------------------------------------------ */

  function leer(clave) {
    try {
      return localStorage.getItem(clave) || '';
    } catch (err) {
      return ''; // modo privado / cookies bloqueadas
    }
  }

  function cobertura() {
    var rutas = leer('mascaRutas')
      .split(',')
      .map(function (r) {
        return r.trim();
      })
      .filter(Boolean);
    return { conDireccion: !!leer('userAddress'), rutas: rutas };
  }

  /** ¿Llega esta ruta a la dirección guardada? Sin dirección no se descarta nada. */
  function llega(ruta, cob) {
    if (!cob.conDireccion || !ruta) return true;
    if (ruta === 'express') return cob.rutas.indexOf('express') !== -1;
    if (ruta === 'nextday') {
      return cob.rutas.indexOf('nextday') !== -1 || cob.rutas.indexOf('bodega') !== -1;
    }
    if (ruta === 'retiro') return cob.rutas.indexOf('retiro') !== -1;
    return false;
  }

  /** Mejor variante comprable: primero la que llega hoy, después mañana. */
  function mejorVariante(variantes, cob) {
    var orden = ['express', 'nextday', 'retiro', ''];
    for (var i = 0; i < orden.length; i++) {
      for (var j = 0; j < variantes.length; j++) {
        var v = variantes[j];
        if (v.ruta === orden[i] && v.disponible && llega(v.ruta, cob)) return v;
      }
    }
    return null;
  }

  function pedirDireccion() {
    var disparador = document.getElementById('change-location-btn');
    if (disparador) disparador.click();
  }

  /* ------------------------------------------------------------------ */
  /* Precios                                                             */
  /* ------------------------------------------------------------------ */

  // CLP sin decimales, con punto de miles: $35.990
  function pesos(centavos) {
    return '$' + Math.round(centavos / 100).toLocaleString('es-CL');
  }

  function porcentaje(v) {
    if (!(v.comparativo > v.precio)) return 0;
    return Math.round(((v.comparativo - v.precio) * 100) / v.comparativo);
  }

  function detalle(v) {
    var partes = [];
    if (v.gramos > 0) partes.push(pesos(v.precio / (v.gramos / 1000)) + ' / kg');
    if (v.comparativo > v.precio) {
      partes.push('<strong>Ahorras ' + pesos(v.comparativo - v.precio) + '</strong>');
    }
    return partes.join(' • ');
  }

  function pintarPrecio(card, v) {
    var antes = card.querySelector('[data-mc-antes]');
    var ahora = card.querySelector('[data-mc-ahora]');
    var off = card.querySelector('[data-mc-off]');
    var det = card.querySelector('[data-mc-detalle]');
    var badge = card.querySelector('[data-mc-badge-off]');
    var pct = porcentaje(v);

    if (ahora) ahora.textContent = pesos(v.precio);
    if (antes) {
      antes.textContent = pct ? pesos(v.comparativo) : '';
      antes.hidden = !pct;
    }
    if (off) {
      off.textContent = pct ? pct + '% OFF' : '';
      off.hidden = !pct;
    }
    if (det) det.innerHTML = detalle(v);
    if (badge) {
      badge.textContent = pct ? pct + '% OFF' : '';
      badge.hidden = !pct;
    }
  }

  /* ------------------------------------------------------------------ */
  /* Una card                                                            */
  /* ------------------------------------------------------------------ */

  function Card(nodo) {
    this.nodo = nodo;
    var json = nodo.querySelector('[data-mc-variantes]');
    try {
      this.variantes = JSON.parse(json ? json.textContent : '[]');
    } catch (err) {
      this.variantes = [];
    }
    this.elegida = null;
    this.conectar();
    this.pintar();
  }

  Card.prototype.variante = function (id) {
    id = Number(id);
    for (var i = 0; i < this.variantes.length; i++) {
      if (this.variantes[i].id === id) return this.variantes[i];
    }
    return null;
  };

  Card.prototype.conectar = function () {
    var self = this;

    this.nodo.querySelectorAll('[data-mc-ruta]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        if (chip.disabled) return;
        self.elegir(self.variante(chip.getAttribute('data-variant-id')));
      });
    });

    this.nodo.querySelectorAll('[data-mc-agregar]').forEach(function (boton) {
      boton.addEventListener('click', function () {
        var id = boton.getAttribute('data-variant-id');
        if (!id || boton.disabled) return;
        agregar(id, boton);
      });
    });
  };

  Card.prototype.elegir = function (v) {
    if (!v) return;
    this.elegida = v;
    this.nodo.querySelectorAll('[data-mc-ruta]').forEach(function (chip) {
      chip.setAttribute('aria-checked', String(Number(chip.getAttribute('data-variant-id')) === v.id));
    });
    var boton = this.nodo.querySelector('[data-mc-agregar]');
    if (boton) boton.setAttribute('data-variant-id', v.id);
    pintarPrecio(this.nodo, v);
  };

  Card.prototype.avisar = function (html) {
    var aviso = this.nodo.querySelector('[data-mc-aviso]');
    if (!aviso) return;
    aviso.innerHTML = html || '';
    aviso.hidden = !html;
    var boton = aviso.querySelector('[data-mc-pedir-direccion]');
    if (boton) boton.addEventListener('click', pedirDireccion);
  };

  Card.prototype.pintar = function () {
    var self = this;
    var cob = cobertura();
    var variantes = this.variantes;
    var mejor = mejorVariante(variantes, cob);
    var varias = variantes.length > 1;

    // 1. Promesa sobre la foto: solo con dirección y con una ruta que llegue.
    var entrega = this.nodo.querySelector('[data-mc-entrega]');
    if (entrega) {
      if (cob.conDireccion && mejor && mejor.ruta === 'express') {
        entrega.innerHTML = ICONO_RAYO + 'Llega hoy';
        entrega.hidden = false;
      } else if (cob.conDireccion && mejor && mejor.ruta === 'nextday') {
        entrega.innerHTML = ICONO_CAMION + 'Llega mañana';
        entrega.hidden = false;
      } else {
        entrega.hidden = true;
      }
    }

    // 2. Rutas que no llegan -> chips deshabilitados.
    this.nodo.querySelectorAll('[data-mc-ruta]').forEach(function (el) {
      var v = self.variante(el.getAttribute('data-variant-id'));
      if (!v) return;
      var ok = v.disponible && llega(v.ruta, cob);
      el.disabled = !ok;
      el.title = !v.disponible ? 'Sin stock' : ok ? '' : 'No llega a tu dirección';
    });

    // 3. Aviso según la dirección.
    if (varias && !cob.conDireccion) {
      this.avisar(
        '<button type="button" data-mc-pedir-direccion>Ingresa tu dirección</button> para ver cuándo te llega.'
      );
    } else if (varias && cob.conDireccion && !mejor) {
      this.avisar('Este producto aún no llega a tu dirección.');
    } else {
      this.avisar('');
    }

    // 4. Variante elegida: la que el comprador tocó si sigue valiendo; si no, la mejor.
    if (!varias) {
      if (variantes[0]) pintarPrecio(this.nodo, variantes[0]);
      return;
    }

    var actual = this.elegida;
    var sigueValida = actual && actual.disponible && llega(actual.ruta, cob);
    var primerChip = this.nodo.querySelector('[data-mc-ruta]');
    this.elegir(
      sigueValida ? actual : mejor || this.variante(primerChip && primerChip.getAttribute('data-variant-id'))
    );
    var boton = this.nodo.querySelector('[data-mc-agregar]');
    if (boton) boton.disabled = !mejor;
  };

  /* ------------------------------------------------------------------ */
  /* Carrito                                                             */
  /* ------------------------------------------------------------------ */

  function elementoDelCarro() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function actualizarContador() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (carro) {
        var badge = document.getElementById('cart-icon-bubble-count');
        if (badge) {
          badge.textContent = carro.item_count;
          badge.classList.toggle('hidden', !carro.item_count);
        }
      })
      .catch(function () {});
  }

  /*
    Mismo patrón que masca-home.js: se piden al carrito las secciones que él
    declara, se repinta con renderContents() y se quita `is-empty` a mano
    (vive en <cart-drawer>, fuera de lo que repinta renderContents; sin quitarla
    el drawer se abre con el total correcto y la lista en blanco).
  */
  function agregar(idVariante, boton) {
    var html = boton.innerHTML;
    boton.disabled = true;
    boton.setAttribute('aria-busy', 'true');

    var carro = elementoDelCarro();
    var secciones = [];
    if (carro && typeof carro.getSectionsToRender === 'function') {
      secciones = carro.getSectionsToRender().map(function (s) {
        return s.id;
      });
    }
    var cuerpo = { items: [{ id: Number(idVariante), quantity: 1 }], sections_url: window.location.pathname };
    if (secciones.length) cuerpo.sections = secciones;
    if (carro && typeof carro.setActiveElement === 'function') carro.setActiveElement(boton);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(cuerpo)
    })
      .then(function (r) {
        return r.json().then(function (datos) {
          if (!r.ok) throw new Error(datos.description || datos.message || 'cart/add ' + r.status);
          return datos;
        });
      })
      .then(function (estado) {
        if (carro && typeof carro.renderContents === 'function' && estado.sections) {
          carro.renderContents(estado);
          if (carro.classList.contains('is-empty')) carro.classList.remove('is-empty');
        }
        actualizarContador();
        boton.classList.add('mc-boton--ok');
        boton.textContent = '✓ Agregado';
        setTimeout(function () {
          boton.classList.remove('mc-boton--ok');
          boton.innerHTML = html;
          boton.disabled = false;
        }, 1600);
      })
      .catch(function (error) {
        console.error('[masca-card-plp] no se pudo agregar:', error);
        boton.textContent = 'No se pudo agregar';
        boton.title = error.message;
        setTimeout(function () {
          boton.innerHTML = html;
          boton.disabled = false;
        }, 4000);
      })
      .finally(function () {
        boton.removeAttribute('aria-busy');
      });
  }

  /* ------------------------------------------------------------------ */
  /* Arranque                                                            */
  /* ------------------------------------------------------------------ */

  var cards = [];

  function iniciar(raiz) {
    (raiz || document).querySelectorAll('[data-mc-card]:not([data-mc-listo])').forEach(function (nodo) {
      nodo.setAttribute('data-mc-listo', '');
      cards.push(new Card(nodo));
    });
  }

  function repintar() {
    cards.forEach(function (c) {
      if (document.body.contains(c.nodo)) c.pintar();
    });
  }

  // La cobertura cambia cuando el comprador confirma otra dirección en el popup.
  document.addEventListener('masca:cobertura-actualizada', repintar);
  window.addEventListener('masca:estado', repintar); // masca-estado.js lo emite en window
  window.addEventListener('storage', function (e) {
    if (e.key === 'mascaRutas' || e.key === 'userAddress') repintar();
  });

  // En el Customizer las secciones se recargan sin recargar la página.
  document.addEventListener('shopify:section:load', function (e) {
    iniciar(e.target);
  });

  // facets.js (filtros) y "Cargar más" reemplazan/agregan HTML de la grilla:
  // las cards nuevas llegan sin listeners, así que se enganchan al aparecer.
  if ('MutationObserver' in window) {
    new MutationObserver(function (cambios) {
      for (var i = 0; i < cambios.length; i++) {
        if (cambios[i].addedNodes.length) {
          iniciar();
          return;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  window.MascaCardPlp = { iniciar: iniciar, repintar: repintar };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciar();
    });
  } else {
    iniciar();
  }
})();
